module.exports = __webpack_public_path__ + "media/images/guide/anotacion/image5-ad83763c7ae2b4c785f0beaa0445ce4f.png";